import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import { useAlert } from "react-alert";
function Credits() {
    const [data, setData] = useState({})
    const [sms, setSms] = useState({})
    const [email, setEmail] = useState({})
    const [Wapp, setWapp] = useState({})
     const [error, setError] = useState({})
       const alert = useAlert();
       const [refresh,setRefresh]=useState(false)
    useEffect(() => {

        const tokenString = sessionStorage.getItem('usertoken');

        let str = tokenString.replace(/["]+/g, '')


        axios.get(`${APIURL}/api/v1/staff/master-credit-system/?${TZ}`, {
            headers: {

                "Authorization": 'Token ' + str
            }
        })
            .then(res => {

                if (res.data.status === "success") {
                    const filteredData1 = res.data.credits.filter(item => {
                        return item.channel_type === 'whatsapp'
                    })
                    const filteredData2 = res.data.credits.filter(item => {
                        return item.channel_type === 'sms'
                    })
                    const filteredData3 = res.data.credits.filter(item => {
                        return item.channel_type === 'email'
                    })
                    setSms(filteredData2[0])
                    setEmail(filteredData3[0])
                    setWapp(filteredData1[0])
                   

                }


            })
            .catch(err => {

            })


    }, [refresh]);
    const validate = () => {
       
        let isValid = true;
       
        if (!data.channel_type||data.channel_type==="") {
            setError((currentstate) => ({
                ...currentstate,
                channel_type: 'Enter count',
              }))
              isValid = false;
          }
           if(!data.count||data.count===""||data.count===null){
            setError((currentstate) => ({
                ...currentstate,
                count: 'Enter count',
              }))
              isValid = false;
          }
           if(!data.price||data.price===""||data.pric===null){
            setError((currentstate) => ({
                ...currentstate,
                price: 'Enter count',
              }))
              isValid = false;
          }
         if((error.count&&error.count!=="")||(error.price&&error.price!=="")){
            isValid = false;
        }
        if(isValid){
            handleSave()
        }
    }
    const handleSave = () => {
      
    
        const tokenString = sessionStorage.getItem("usertoken");
      
        let str = tokenString.replace(/["]+/g, "");
     
        const dataToUpdate = {
            credits:1,
            count:data.count,
            price:data.price,
            channel_type:data.channel_type
        };


        axios
            .post(`${APIURL}/api/v1/staff/master-credit-system/`, dataToUpdate, {
                headers: {
                    Authorization: "Token " + str,
                    "Content-Type": "application/json",
                },
            })

            .then((res) => {

                if (res.data.status === "success") {
                    alert.success(res.data.message)
                    setData({
                        channel_type: "",
                        count:"",
                        price:""
                    })
                    setRefresh(!refresh)
                } else {
                    alert.error(res.data.message);
                }
            })
            .catch((err) => {
                alert.error("error in submission")
            });
        
    };
    const displayCredits = (item) => {


        return (
            <div className="col-12" style={{ padding: "1%" }}>
                <div style={{ border: "1px solid gray", borderRadius: "5px", backgroundColor: "#cbdadb", padding: "1%" }}>
                    <div className="d-flex justify-content-between">
                        <b> <h6 style={{}}className="col-12">{item.count} Messages/Credit</h6></b>

                        <>&nbsp;<b> QAR{item.price}/-</b></>

                    </div>

                    <div style={{ backgroundColor: "white", padding: "1%" }}>
                        <div className="row" style={{ margin: "auto" }}>
                           
                            <small className="col-6">Minimum limit</small>

                            <b className="col-6"style={{fontSize:"14px"}}>
                                {item.min_limit}
                            </b>
                            <small className="col-6">Updated date</small>

                            <b className="col-6"style={{fontSize:"14px"}}>
                                {item.updated_date}
                            </b>

                        </div>
                    </div>
                </div>
            </div>
        );
    };
    return (
        <div className="row" style={{ marginBottom: "1%", }}>

            <div className="col-4" style={{ border: "1px solid gray", borderRadius: "5px", backgroundColor: "#FDF5EE", padding: "1%" }}>
                <h6 className="row">
                    <div className="col-3"><b >Sms</b></div>
                    <div className="col-8 row">



                    </div>
                    {/* <div className="col-1">
                        <button onClick={(e) => { }
                        } style={{ cursor: "pointer", height: "22px" }} className="clinic_button"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M18 10h-4V6a2 2 0 0 0-4 0l.071 4H6a2 2 0 0 0 0 4l4.071-.071L10 18a2 2 0 0 0 4 0v-4.071L18 14a2 2 0 0 0 0-4" /></svg></button>
                    </div> */}

                </h6>
                <div className="container-fluid">
                    <div className="row">
                        {displayCredits(sms)}

                    </div>
                </div>

            </div>
            <div className=" col-4" style={{ border: "1px solid gray", borderRadius: "5px", backgroundColor: "#F9FEF8", padding: "1%", }}>
                <h6 className="row">
                    <div className="col-3"><b >Whatsapp</b></div>
                    <div className="col-8 row">
                    </div>
                    {/* <div className="col-1">
                        <button onClick={(e) => { }
                        } style={{ cursor: "pointer", height: "22px" }} className="clinic_button"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M18 10h-4V6a2 2 0 0 0-4 0l.071 4H6a2 2 0 0 0 0 4l4.071-.071L10 18a2 2 0 0 0 4 0v-4.071L18 14a2 2 0 0 0 0-4" /></svg></button>
                    </div> */}

                </h6>
                <div className="container-fluid">
                    <div className="row">
                        {displayCredits(Wapp)}
                    </div>
                </div>
            </div>
            <div className="col-4" style={{ border: "1px solid gray", borderRadius: "5px", backgroundColor: "#FAF1F3", padding: "1%", }}>
                <h6 className="row">
                    <div className="col-3"><b >Email</b></div>
                    <div className="col-8 row">
                    </div>
                    {/* <div className="col-1">
                        <button onClick={(e) => { }
                        } style={{ cursor: "pointer", height: "22px" }} className="clinic_button"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M18 10h-4V6a2 2 0 0 0-4 0l.071 4H6a2 2 0 0 0 0 4l4.071-.071L10 18a2 2 0 0 0 4 0v-4.071L18 14a2 2 0 0 0 0-4" /></svg></button>
                    </div> */}

                </h6>
                <div className="container-fluid">
                    <div className="row">

                        {displayCredits(email)}


                    </div>
                </div>
            </div>
            
            <div className="col-6" style={{marginTop:"3%"}}><b >New Credit +</b></div>
            <div className="col-12" style={{ border: "1px solid gray", borderRadius: "5px",  padding: "1%" }}>
                <div className="row">
                <div className="col-3" style={{ marginTop: "1%" }}>
                    <span className="">Plan type:</span>

                    <select
                        name='allergytype'
                        className={`${error.channel_type ? 'error-border' : 'clinc_input'}`}
                        style={{ padding: "auto", marginTop: "0.5%", width: "100%" }}
                        value={data.channel_type}
                        onChange={(e) => {
                            setData((currentstate) => ({
                                ...currentstate,
                                channel_type: e.target.value,
                            }))
                            if (e.target.value <0||e.target.value===""||e.target.value===null) {
                                setError((currentstate) => ({
                                    ...currentstate,
                                    channel_type: 'Enter count',
                                  }))
                                
                              }
                              else {
                                setError((currentstate) => ({
                                    ...currentstate,
                                    channel_type: '',
                                  }))
                              }
                            
                        }}>
                        <option value="" selected hidden  >Select type</option>
                        <option value="sms" >Sms</option>
                        <option value="email" >Email</option>
                        <option value="whatsapp" >Whatsapp</option>


                    </select>
                     </div>
               
                <div className="col-3" style={{ paddingTop: "1%" }}>
                            <span className="">Message Count</span><br />
                            <input
                                className={`${error.count ? 'error-border' : 'clinc_input'}`}
                                type="number"
                                maxLength="100"
                                placeholder=""
                                value={data.count}
                                style={{ width: "100%" }}
                                onChange={(e) =>{ setData((currentstate) => ({
                                    ...currentstate,
                                    count: e.target.value,
                                })
                                
                                );
                                if (e.target.value <0||e.target.value===""||e.target.value===null) {
                                    setError((currentstate) => ({
                                        ...currentstate,
                                        count: 'Enter count',
                                      }))
                                    
                                  }
                                  else {
                                    setError((currentstate) => ({
                                        ...currentstate,
                                        count: '',
                                      }))
                                  }
                                }
                            }
                            /></div>
                            <div className="col-3" style={{ paddingTop: "1%" }}>
                            <span className="">Price</span><br />
                            <input
                                className={`${error.price ? 'error-border' : 'clinc_input'}`}
                                type="number"
                                maxLength="100"
                                placeholder=""
                                value={data.price}
                                style={{ width: "100%" }}
                                onChange={(e) =>{ setData((currentstate) => ({
                                    ...currentstate,
                                    price: e.target.value,
                                })
                                );
                                if (e.target.value <0||e.target.value===""||e.target.value===null) {
                                    setError((currentstate) => ({
                                        ...currentstate,
                                        price: 'Enter price',
                                      }))
                                    
                                  }
                                  else {
                                    setError((currentstate) => ({
                                        ...currentstate,
                                        price: '',
                                      }))
                                  }
                            }}
                            /></div>
                             <div className="col-3" style={{ paddingTop: "1%" }}>
                             <span className=""></span><br />
                    <button onClick={(e) => {validate()  } }
                     style={{ backgroundColor: "#55479F", width: "100%" }} className="clinic_button">Submit</button>
                </div>
            </div>
            </div>

        </div>
    );
}
export default Credits;
